import React, { useEffect, useState } from "react";
import {
  Modal,
  Input,
  Select,
  Button,
  Checkbox,
  Avatar,
  Space,
  Typography,
} from "antd";
import FloatLabel from "../FloatLabel";
import { SearchOutlined } from "@ant-design/icons";
import "./CollaborationModal.css";

const { Option } = Select;
const { Title, Text } = Typography;

const CollaborationModal = ({
  visible,
  onCancel,
  onSave,
  collaborators,
  initialSelected,
  permissionMetadata,
  tabName,
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [allUsers, setAllUsers] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [selected, setSelected] = useState([]);
  const [inviteEmail, setInviteEmail] = useState("");
  const [invitePermission, setInvitePermission] = useState(
    permissionMetadata.find((p) => p.name === "Can View") || permissionMetadata[0]
  );

  // Merge collaborators with initialSelected and prepare permissions
  useEffect(() => {
  if (!visible) return;

  // Enrich users with permission if they exist in initialSelected
  const enrichedUsers = collaborators.map((user) => {
    const match = initialSelected.find((sel) => String(sel.member_id) === String(user.id));
    const permission =
      match
        ? permissionMetadata.find(p => String(p.id) === String(match.permission_id))
        : permissionMetadata.find(p => p.name === "Can View") || permissionMetadata[0];
    return {
      ...user,
      permission,
    };
  });

  // Merge unique users from collaborators + any extra in initialSelected
  const mergedUsers = [
    ...enrichedUsers,
    ...initialSelected.map(user => ({
      id: user.member_id || user.id,
      name: user.name || "",
      email: user.email || "",
      avatar: user.avatar || "",
      permission:
        permissionMetadata.find(p => String(p.id) === String(user.permission_id))
        || permissionMetadata.find(p => p.name === "Can View") || permissionMetadata[0],
    }))
  ];

  // Deduplicate by id
  const uniqueUsers = Array.from(
    new Map(mergedUsers.map(u => [String(u.id), u])).values()
  );

  setAllUsers(uniqueUsers);
  setSelected(
    uniqueUsers.filter((u) =>
      initialSelected.some((sel) => String(sel.member_id || sel.id) === String(u.id))
    )
  );
  setSearchTerm("");
  setInviteEmail("");
  setInvitePermission(permissionMetadata.find(p => p.name === "Can View") || permissionMetadata[0]);
}, [visible]);

  // Filter users on search term
  useEffect(() => {
    setFiltered(
      allUsers.filter(
        (user) =>
          user.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchTerm.toLowerCase())
      )
    );
  }, [searchTerm, allUsers]);

  const handleSearch = (e) => setSearchTerm(e.target.value);

  const toggleSelection = (user) => {
    const exists = selected.find((u) => u.id === user.id);
    if (exists) {
      setSelected(selected.filter((u) => u.id !== user.id));
    } else {
      setSelected([...selected, user]);
    }
  };

  const updatePermission = (userId, permissionId) => {
    const newPermission = permissionMetadata.find((p) => p.id === permissionId);
    setAllUsers((prev) =>
      prev.map((u) => (u.id === userId ? { ...u, permission: newPermission } : u))
    );
    setSelected((prev) =>
      prev.map((u) => (u.id === userId ? { ...u, permission: newPermission } : u))
    );
  };

  const handleInvite = () => {
    if (!inviteEmail.trim()) return;

    const newUser = {
      id: `invite-${Date.now()}`,
      name: inviteEmail.split("@")[0],
      email: inviteEmail,
      // avatar: `https://i.pravatar.cc/40?u=${inviteEmail}`,
      permission: invitePermission,
      newInvitee: true,
    };

    setAllUsers((prev) => [...prev, newUser]);
    setSelected((prev) => [...prev, newUser]);
    setInviteEmail("");
    setInvitePermission(permissionMetadata.find(p => p.name === "Can View") || permissionMetadata[0]);
  };
  const modalTitle = tabName === "event" ? "Participants" : "Collaboration";
  return (
    <Modal
      title={<Title level={4}>{modalTitle}</Title>}
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={600}
    >
      <div style={{ marginBottom: 15 }}>
        <FloatLabel label="Search" name="search" value={searchTerm}>
          <Input
            value={searchTerm}
            className="custom-search-input has-prefix"
            prefix={<SearchOutlined />}
            placeholder=""
            onChange={handleSearch}
          />
        </FloatLabel>
      </div>

      {filtered.map((user) => {
        return(
        <div
          key={user.id}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: 30,
          }}
        >
          <Space>
            <Select
              // value={user.permission?.id || permissionMetadata[0].id}
               value={
                // Find in selected state first
                (selected && selected.length  && selected.find(u => u?.id === user?.id)?.permission?.id) ||
                user.permission?.id ||
                permissionMetadata[0]?.id
              }
              onChange={(val) => updatePermission(user.id, val)}
              style={{ width: 120 }}
              className="selectPermission"
            >
              {permissionMetadata.map((option) => (
                <Option key={option.id} value={option.id}>
                  {option?.label_name  || option?.name }
                </Option>
              ))}
            </Select>
            <Avatar src={user?.avatar} />
            <Text>{user.email}</Text>
          </Space>
          <Checkbox
            checked={!!selected.find((u) => u.id === user.id)}
            onChange={() => toggleSelection(user)}
          />
        </div>
        )
})}

      {/* <div style={{ marginTop: 24 }}>
        <Text strong>Invite Members</Text>
        <div className="inaviteEmailSection" style={{ display: "flex", gap: 8, marginTop: 8 }}>
          <FloatLabel label="Email" name="inviteNewEmail" value={inviteEmail}>
            <Input
              value={inviteEmail}
              placeholder=""
              onChange={(e) => setInviteEmail(e.target.value)}
            />
          </FloatLabel>
          <Select
            value={invitePermission?.id}
            onChange={(val) =>
              setInvitePermission(
                permissionMetadata.find((p) => p.id === val) || permissionMetadata[0]
              )
            }
            className="selectPermission"
            style={{ width: 120 }}
          >
            {permissionMetadata.map((option) => (
              <Option key={option.id} value={option.id}>
                {option?.label_name  || option?.name }
              </Option>
            ))}
          </Select>
          <Button type="primary" onClick={handleInvite} className="invite-control">
            Invite
          </Button>
        </div>
      </div> */}

      <div style={{ textAlign: "right", marginTop: 32 }}>
        <Button
          type="primary"
          className="setup-btn"
          block
          style={{
            backgroundColor: "#a855f7",
            borderColor: "#a855f7",
            color: "#fff",
          }}
          onClick={() => onSave(selected)}
          // disabled={selected.length === 0}
        >
          Save
        </Button>
      </div>
    </Modal>
  );
};

export default CollaborationModal;
